<div class="p-4">
    <!-- Search Input -->
    <div class="mb-4 flex items-center gap-2">
      <mat-form-field class="flex-1" appearance="outline">
        <mat-icon matPrefix class="icon-base">search</mat-icon>
        <input
          matInput
          placeholder="Buscar funcionalidades..."
          [ngModel]="searchTerm()"
          (ngModelChange)="onSearchChange($event)"
          autofocus
        />
      </mat-form-field>
      <button mat-icon-button (click)="close()" aria-label="Fechar busca">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  
    <!-- Results -->
    <div class="search-results max-h-96 overflow-y-auto">
      @if (filteredResults().length === 0) {
        <div class="py-8 text-center">
          <mat-icon class="mb-2 icon-3xl">search_off</mat-icon>
          <p class="text-sm">Nenhum resultado encontrado</p>
        </div>
      } @else {
        <mat-nav-list>
          @for (result of filteredResults(); track result.route) {
            <mat-list-item (click)="navigateTo(result.route)" class="cursor-pointer">
              <mat-icon matListItemIcon class="text-pmdf-primary">{{ result.icon }}</mat-icon>
              <div matListItemTitle class="font-medium">{{ result.title }}</div>
              <div matListItemLine class="text-xs">{{ result.description }}</div>
              <span matListItemMeta class="text-xs">{{ result.category }}</span>
            </mat-list-item>
          }
        </mat-nav-list>
      }
    </div>
  </div>
  
